import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=43f15f4f&scoped=true&"
import script from "@/scripts/Referral/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Referral/index.js?vue&type=script&lang=js&"
import style0 from "./Referral.vue?vue&type=style&index=0&id=43f15f4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f15f4f",
  null
  
)

export default component.exports